const formulariosRequisito = document.querySelectorAll(
    '[data-form-requisito]'
);

formulariosRequisito.forEach(formulario => {
    const interruptor = formulario.querySelector(
        '.switch-contrato-input'
    );

    const texto = formulario.querySelector(
        '[data-texto-requisito]'
    );

    if (!interruptor || !texto) {
        return;
    }

    interruptor.addEventListener('change', async () => {
        /*
         * Guardamos temporalmente el estado anterior
         * para restaurarlo si ocurre un error.
         */
        const estadoAnterior = !interruptor.checked;
        let debeQuedarBloqueado = false;

        interruptor.disabled = true;
        formulario.classList.add('guardando');

        try {
            const datosFormulario = new FormData(
                formulario
            );

            const respuesta = await fetch(
                formulario.action,
                {
                    method: 'POST',
                    body: datosFormulario,
                    headers: {
                        'X-Requested-With':
                            'XMLHttpRequest'
                    }
                }
            );

            const datos = await respuesta.json();
            debeQuedarBloqueado =
                Boolean(datos.bloqueado);


            if (!respuesta.ok || !datos.resultado) {
                throw new Error(
                    datos.mensaje ||
                    'No se pudo actualizar.'
                );
            }

            /*
             * Sincronizamos el interruptor con el
             * valor confirmado por la base de datos.
             */
            interruptor.checked =
                Number(datos.nuevo_valor) === 1;

            texto.textContent = datos.texto;

            formulario.classList.add('actualizado');

            setTimeout(() => {
                formulario.classList.remove(
                    'actualizado'
                );
            }, 700);

        } catch (error) {
            interruptor.checked = estadoAnterior;

            alert(
                error.message ||
                'No se pudo actualizar el contrato.'
            );

        } finally {
            interruptor.disabled =
                debeQuedarBloqueado;

            formulario.classList.remove(
                'guardando'
            );
        }
    });
});





























const formulariosAnular = document.querySelectorAll(
    '[data-form-anular]'
);

formulariosAnular.forEach(formulario => {
    formulario.addEventListener(
        'submit',
        async evento => {
            evento.preventDefault();

            const confirmado = window.confirm(
                '¿Está seguro de anular este contrato?'
            );

            if (!confirmado) {
                return;
            }

            const boton = formulario.querySelector(
                'button[type="submit"]'
            );

            const fila = formulario.closest(
                '[data-fila-contrato]'
            );

            const estado = fila?.querySelector(
                '[data-estado-contrato]'
            );

            const requisitos = fila?.querySelector(
                '[data-requisitos-contrato]'
            );

            const editar = fila?.querySelector(
                '[data-accion-editar]'
            );

            if (boton) {
                boton.disabled = true;
                boton.textContent = 'Anulando...';
            }

            try {
                const respuesta = await fetch(
                    formulario.action,
                    {
                        method: 'POST',
                        body: new FormData(formulario),
                        headers: {
                            'X-Requested-With':
                                'XMLHttpRequest'
                        }
                    }
                );

                const datos = await respuesta.json();

                if (!respuesta.ok || !datos.resultado) {
                    throw new Error(
                        datos.mensaje ||
                        'No se pudo anular el contrato.'
                    );
                }

                /*
                 * Actualizamos visualmente la fila
                 * sin recargar la página.
                 */
                if (estado) {
                    estado.innerHTML = `
                        <span
                            class="estado-usuario estado-inactivo">
                            Anulado
                        </span>
                    `;
                }

                if (requisitos) {
                    requisitos.innerHTML = `
                        <span
                            class="switch-contrato-anulado">
                            Contrato anulado
                        </span>
                    `;
                }

                /*
                 * Un contrato anulado ya no puede
                 * editarse ni volver a anularse.
                 */
                editar?.remove();
                formulario.remove();

                fila?.classList.add(
                    'fila-contrato-anulada'
                );

            } catch (error) {
                alert(
                    error.message ||
                    'No se pudo anular el contrato.'
                );

                if (boton) {
                    boton.disabled = false;
                    boton.textContent = 'Anular';
                }
            }
        }
    );
});